import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ThreeDService } from 'src/app/services/three-d.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { StepFiveSliderComponent } from './step-five-slider/step-five-slider.component';
import { debounceTime } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { DoorType } from 'src/app/enums/doorType.enum';
import { DoorDirection } from 'src/app/enums/doorDirection.enum';
import { DoorPosition } from 'src/app/models/doorPosition.model';
import { WallSide } from 'src/app/enums/wallSide.enum';
import { StepService } from 'src/app/services/step.service';
import { DoorDimensionSliderComponent } from './door-dimension-slider/door-dimension-slider.component';
import { PriceService } from 'src/app/services/price.service';
import { FinishTypes } from 'src/app/enums/finishTypes.enum';
import { ViewboxOptionWithPrice } from 'src/app/models/wallFinishType.model';
import { ViewboxOption } from 'src/app/models/viewboxOption.model';
import { StartupService } from 'src/app/services/startup.service';
import { Purpose } from 'src/app/enums/purpose';
import { NotificationService } from 'src/app/services/notification.service';
import { DoorHandleType } from 'src/app/enums/doorHandleType.enum';
import { HingeType } from 'src/app/enums/hingeType.enum';
import { InnerWall } from 'src/app/models/innerWall.model';
import { ProductClassificationService } from 'src/app/services/product-classification.service';
import { ProductClass } from 'src/app/enums/productClass.enum';

@Component({
  selector: 'app-step-five',
  templateUrl: './step-five.component.html',
  styleUrls: ['./step-five.component.scss'],
})
export class StepFiveComponent implements OnInit, OnDestroy {
  remainingSpaceToLeft: number;
  remainingSpaceToRight: number;
  hasSelectedDoor: boolean;
  widthHeightRangeTurnDoor: number[][] = [
    //internal width, internal height, panel height
    [620, 1800, 1800],
    [620, 1800, 2100],
    [620, 1985, 2100],
    [620, 2000, 2400],
    [620, 2100, 2400],
    [620, 2200, 2400],
    [700, 1800, 1800],
    [700, 1800, 2100],
    [700, 1985, 2100],
    [700, 2000, 2400],
    [700, 2100, 2400],
    [700, 2200, 2400],
    [800, 1800, 1800],
    [800, 1800, 2100],
    [800, 1985, 2100],
    [800, 2000, 2400],
    [800, 2100, 2400],
    [800, 2200, 2400],
    [900, 1800, 1800],
    [900, 1800, 2100],
    [900, 1985, 2100],
    [900, 2000, 2400],
    [900, 2100, 2400],
    [900, 2200, 2400],
    [1000, 1800, 1800],
    [1000, 1800, 2100],
    [1000, 1985, 2100],
    [1000, 2000, 2400],
    [1000, 2100, 2400],
    [1000, 2200, 2400],
    [1100, 1800, 1800],
    [1100, 1800, 2100],
    [1100, 1985, 2100],
    [1100, 2000, 2400],
    [1100, 2100, 2400],
    [1100, 2200, 2400],
    [1200, 1800, 1800],
    [1200, 1800, 2100],
    [1200, 1985, 2100],
    [1200, 2000, 2400],
    [1200, 2100, 2400],
    [1200, 2200, 2400],
    [1400, 1800, 1800],
    [1400, 1800, 2100],
    [1400, 1985, 2100],
    [1400, 2000, 2400],
    [1400, 2100, 2400],
    [1400, 2200, 2400],
    [1500, 1800, 1800],
    [1500, 1800, 2100],
    [1500, 1985, 2100],
    [1500, 2000, 2400],
    [1500, 2100, 2400],
    [1500, 2200, 2400],
  ];
  widthHeightRangeSlideDoor: number[][] = [
    [800, 1900, 2100],
    [800, 2000, 2400],
    [800, 2100, 2400],
    [800, 2200, 2400],
    [800, 2400, 2700],
    [900, 1900, 2100],
    [900, 2000, 2400],
    [900, 2100, 2400],
    [900, 2200, 2400],
    [900, 2400, 2700],
    [1000, 1900, 2100],
    [1000, 2000, 2400],
    [1000, 2100, 2400],
    [1000, 2200, 2400],
    [1000, 2400, 2700],
    [1100, 1900, 2100],
    [1100, 2000, 2400],
    [1100, 2100, 2400],
    [1100, 2200, 2400],
    [1100, 2400, 2700],
    [1200, 1900, 2100],
    [1200, 2000, 2400],
    [1200, 2100, 2400],
    [1200, 2200, 2400],
    [1200, 2400, 2700],
    [1400, 1900, 2100],
    [1400, 2000, 2400],
    [1400, 2100, 2400],
    [1400, 2200, 2400],
    [1400, 2400, 2700],
    [1500, 1900, 2100],
    [1500, 2000, 2400],
    [1500, 2100, 2400],
    [1500, 2200, 2400],
    [1500, 2400, 2700],
  ];

  @ViewChild('slider') slider: StepFiveSliderComponent;
  collided$: EventEmitter<boolean> = new EventEmitter<boolean>();
  currentSide: WallSide;
  @ViewChild('doorWidth') doorWidth: DoorDimensionSliderComponent;
  @ViewChild('doorHeight') doorHeight: DoorDimensionSliderComponent;
  _externalDoorFinishOptions: ViewboxOptionWithPrice<FinishTypes>[];
  _internalDoorFinishOptions: ViewboxOptionWithPrice<FinishTypes>[];
  pricesVisible: boolean;
  doorOpeningWidth: number;
  doorOpeningHeight: number;
  clearWidthPro: boolean = false;
  clearHeightPro: boolean = false;
  private unsubscribe: Subject<void> = new Subject();
  private debouncer = new Subject();
  private subscription: Subscription;

  constructor(
    private configurationService: ConfigurationService,
    private threeDService: ThreeDService,
    private translateService: TranslateService,
    private stepService: StepService,
    private changeDetector: ChangeDetectorRef,
    private priceService: PriceService,
    private notificationService: NotificationService,
    private startupService: StartupService,
    private productClassificationService: ProductClassificationService
  ) {
    this.configurationService.registerNewDoors = true;
  }

  private _selectedDoor: DoorPosition | null = null;

  get selectedDoor(): DoorPosition {
    return this._selectedDoor;
  }

  set selectedDoor(selectedDoor: DoorPosition) {
    if (!selectedDoor) {
      this._selectedDoor = null;
      return;
    }

    if (!this._selectedDoor) {
      this._selectedDoor = new DoorPosition(
        0,
        -1,
        WallSide.south,
        620,
        1780,
        900,
        this.configurationService.height,
        FinishTypes.STEEL,
        FinishTypes.STEEL
      );
    }

    if (this._selectedDoor.equals(selectedDoor)) {
      return;
    }

    this._selectedDoor = selectedDoor;

    this.doorOpeningWidth = this.selectedDoor.doorModel.openingWidth;
    this.doorOpeningHeight = this.selectedDoor.doorModel.openingHeight;

    this.changeDetector.detectChanges();

    if (this.slider) {
      this.slider.positionFromLeftLimit = this.calculateRemainingSpaceToLeft();
      this.slider.positionFromRightLimit = this.calculateRemainingSpaceToRight();
      this.slider.setViewPosition();
    }

    if (this.doorWidth.valueChanged) {
      this.doorWidth.valueChanged.pipe(takeUntil(this.doorWidth.unsubscribe)).subscribe((value: number) => {
        if (this.threeDService.isValidDoorWidth(value)) {
          this.threeDService.setSelectedDoorWidth(value);
          this.doorOpeningWidth = value;
          let doorWidthProductClass = this.productClassificationService.GetDoorProductClassByWidth(this.doorOpeningWidth);
          if (this.doorOpeningHeight < this.heightRange[0]) {
            this.doorOpeningHeight = this.heightRange[0];
            this.threeDService.setSelectedDoorHeight(this.doorOpeningHeight);
            const doorHeightProductClass = this.productClassificationService.GetDoorProductClassByHeight(this.doorOpeningHeight);
            if (doorWidthProductClass === ProductClass.STANDARD && doorWidthProductClass !== doorHeightProductClass) {
              doorWidthProductClass = doorHeightProductClass;
            }
          }
          if (this.doorOpeningHeight > this.heightRange[this.heightRange.length - 1]) {
            this.doorOpeningHeight = this.heightRange[this.heightRange.length - 1];
            this.threeDService.setSelectedDoorHeight(this.doorOpeningHeight);
            const doorHeightProductClass = this.productClassificationService.GetDoorProductClassByHeight(this.doorOpeningHeight);
            if (doorWidthProductClass === ProductClass.STANDARD && doorWidthProductClass !== doorHeightProductClass) {
              doorWidthProductClass = doorHeightProductClass;
            }
          }
          
          this.clearWidthPro = doorWidthProductClass !== ProductClass.STANDARD;
          this.configurationService.productClass = doorWidthProductClass;
          
          this.configurationService.updateDoorSettings();
          this.updatePricesForDoorFinishes();
          this.updatePricesForDoorHandleTypes();
          this.updatePricesForHingeTypes();
          this.priceService.updatePrice(this.configurationService.configuration);
        } else {
          this.notificationService.showNotification('NOTIFICATIONS.DOOR.TOOWIDE', NotificationService.DEFAULT_TIMEOUT);
          setTimeout(() => {
            this.doorWidth.value = this.selectedDoor.doorModel.openingWidth;
          });
        }
      });
    }
    if (this.doorHeight && this.doorHeight.valueChanged) {
      this.doorHeight.valueChanged.pipe(takeUntil(this.doorHeight.unsubscribe)).subscribe((value: number) => {
        if (this.threeDService.isValidDoorHeight(value)) {
          this.threeDService.setSelectedDoorHeight(value);
          this.doorOpeningHeight = value;
          let doorHeightProductClass = this.productClassificationService.GetDoorProductClassByHeight(this.doorOpeningHeight);
          if (this.doorOpeningWidth < this.widthRange[0]) {
            this.doorOpeningWidth = this.widthRange[0];
            this.threeDService.setSelectedDoorWidth(this.doorOpeningWidth);
            const doorWidthProductClass = this.productClassificationService.GetDoorProductClassByWidth(this.doorOpeningWidth);
            if (doorHeightProductClass === ProductClass.STANDARD && doorWidthProductClass !== doorHeightProductClass) {
              doorHeightProductClass = doorWidthProductClass;
            }
          }
          if (this.doorOpeningWidth > this.widthRange[this.widthRange.length - 1]) {
            this.doorOpeningWidth = this.widthRange[this.widthRange.length - 1];
            this.threeDService.setSelectedDoorWidth(this.doorOpeningWidth);
            const doorWidthProductClass = this.productClassificationService.GetDoorProductClassByWidth(this.doorOpeningWidth);
            if (doorHeightProductClass === ProductClass.STANDARD && doorWidthProductClass !== doorHeightProductClass) {
              doorHeightProductClass = doorWidthProductClass;
            }
          }

          this.clearHeightPro = doorHeightProductClass !== ProductClass.STANDARD;
          this.configurationService.productClass = doorHeightProductClass;

          this.configurationService.updateDoorSettings();
          this.updatePricesForDoorFinishes();
          this.updatePricesForDoorHandleTypes();
          this.updatePricesForHingeTypes();
          this.priceService.updatePrice(this.configurationService.configuration);
        } else {
          this.notificationService.showNotification('NOTIFICATIONS.DOOR.TOOHIGH', NotificationService.DEFAULT_TIMEOUT);
          setTimeout(() => {
            this.doorHeight.value = this.selectedDoor.doorModel.openingHeight;
          });
        }
      });
    }
  }

  _choosingDoorType: boolean;

  get choosingDoorType(): boolean {
    return this._choosingDoorType;
  }

  set choosingDoorType(value: boolean) {
    this._choosingDoorType = value;
    this.changeDetector.detectChanges();
  }

  _doorHandleTypes: ViewboxOptionWithPrice<DoorHandleType>[];

  get doorHandleTypes(): ViewboxOptionWithPrice<DoorHandleType>[] {
    return this._doorHandleTypes;
  }

  _doorHingeTypes: ViewboxOptionWithPrice<HingeType>[];

  get doorHingeTypes(): ViewboxOptionWithPrice<HingeType>[] {
    return this._doorHingeTypes;
  }

  get widthRange(): number[] {
    if (this.selectedDoor.doorModel.type === DoorType.Turn) {
      return this.widthHeightRangeTurnDoor.map(wh => wh[0]);
    } else if (this.selectedDoor.doorModel.type === DoorType.Slide) {
      return this.widthHeightRangeSlideDoor.map(wh => wh[0]);
    }
  }

  get heightRange(): number[] {
    if (this.selectedDoor.doorModel.type === DoorType.Turn) {
      return this.widthHeightRangeTurnDoor
        .filter(wh => wh[0] === this.doorOpeningWidth && wh[2] <= this.configurationService.height)
        .map(wh => wh[1]);
    } else if (this.selectedDoor.doorModel.type === DoorType.Slide) {
      return this.widthHeightRangeSlideDoor
        .filter(wh => wh[0] === this.doorOpeningWidth && wh[2] <= this.configurationService.height)
        .map(wh => wh[1]);
    }
  }

  get externalDoorFinishTypes(): ViewboxOptionWithPrice<FinishTypes>[] {
    return this._externalDoorFinishOptions;
  }

  get internalDoorFinishTypes(): ViewboxOptionWithPrice<FinishTypes>[] {
    return this._internalDoorFinishOptions;
  }

  get canUseSlideDoor() {
    return this.currentSide !== WallSide.inner;
  }

  get canUseTurnDoor() {
    return this.currentSide !== WallSide.inner || this.configurationService.configuration.settings.heightInMM > 1800;
  }

  get anyDoors(): boolean {
    return this.configurationService.configuration.settings.doorSettings.length > 0;
  }

  get noDoorImage() {
    if (this.anyDoors) {
      return '/assets/images/doors/nodoor.png';
    }
    return '/assets/svg/icon-geendeuren.svg';
  }

  get doorInstructionTitle() {
    if (this.configurationService.configuration.settings.doorSettings.length === 0) {
      return this.translateService.instant('STEP5.NODOORADDED');
    } else if (!this.selectedDoor) {
      return this.translateService.instant('STEP5.NODOORSELECTED');
    }
  }

  get doorInstructionText() {
    if (this.configurationService.configuration.settings.doorSettings.length === 0) {
      return this.translateService.instant('STEP5.ADDBYPLUS');
    } else if (!this.selectedDoor) {
      return this.translateService.instant('STEP5.SELECTBYCLICK');
    }
  }

  get turnLeft(): boolean {
    return this.selectedDoor ? this.selectedDoor.doorModel.direction === DoorDirection.left : false;
  }

  get isTurnType(): boolean {
    return this.selectedDoor ? this.selectedDoor.doorModel.type === DoorType.Turn : false;
  }

  get isSlideType(): boolean {
    return this.selectedDoor ? this.selectedDoor.doorModel.type == DoorType.Slide : false;
  }

  ngOnInit() {
    this.choosingDoorType = false;

    this._externalDoorFinishOptions = Object.values(this.configurationService.externalDoorFinishViewboxOptions).filter(x => x.disabled === false);
    this._internalDoorFinishOptions = Object.values(this.configurationService.internalDoorFinishViewboxOptions).filter(x => x.disabled === false);
    this._doorHandleTypes = Object.values(this.configurationService.doorHandleTypes).filter(x => x != null);
    if (this.configurationService.purpose === Purpose.Freezing && this.configurationService.wallThickness < 100) {
      this._doorHandleTypes = this._doorHandleTypes.filter(
        t => t.option !== DoorHandleType.euro2000 && t.option != DoorHandleType.euro2016
      );
    }
    this._doorHingeTypes = Object.values(this.configurationService.doorHingeTypes);
    this.stepService.blockForwardUntilMoreThanOneDoorSelected();
    this.configurationService.setHideFrontWalls(false);
    this.threeDService.wallSelectionEnabled = true;
    this.threeDService.doorSelectionEnabled = true;
    this.threeDService.innerWallSelectionEnabled = true;
    this.threeDService.setZoom(3.75);

    this.productClassificationService.SetFinishClassification(this._externalDoorFinishOptions);
    this.productClassificationService.SetFinishClassification(this._internalDoorFinishOptions);
    this.productClassificationService.SetHingeClassification(this._doorHingeTypes);
    this.productClassificationService.SetDoorHandleClassification(this._doorHandleTypes);

    this.startupService.priceEnabledSetting$.pipe(takeUntil(this.unsubscribe)).subscribe((enabled: boolean) => {
      this.pricesVisible = enabled;
    });

    this.threeDService.doorSelected$.pipe(takeUntil(this.unsubscribe)).subscribe(async (door: DoorPosition) => {
      this.selectedDoor = this.configurationService.configuration.settings.doorSettings.find(d => d.id === door.id);
      if (door.side > -1) {
        this.setCameraOnSide(door.side);
      }
      if (this.slider) {
        this.slider.positionFromLeftLimit = this.calculateRemainingSpaceToLeft();
        this.slider.positionFromRightLimit = this.calculateRemainingSpaceToRight();
        this.slider.setViewPosition();
      }
      this.updateSelectedViewboxOption();
      this.updatePricesForDoorFinishes();
      this.updatePricesForDoorHandleTypes();
      this.updatePricesForHingeTypes();
      this.changeDetector.detectChanges();
      
      this.clearWidthPro = this.productClassificationService.GetDoorProductClassByWidth(this.selectedDoor.doorModel.openingWidth) !== ProductClass.STANDARD;
      this.clearHeightPro = this.productClassificationService.GetDoorProductClassByHeight(this.selectedDoor.doorModel.openingHeight) !== ProductClass.STANDARD;
    });

    this.threeDService.selectFirstDoor();

    this.threeDService.doorAdded$.pipe(takeUntil(this.unsubscribe)).subscribe((door: DoorPosition) => {
      this.selectedDoor = this.configurationService.configuration.settings.doorSettings.find(d => d.id === door.id);
      if (door.side > -1) {
        this.threeDService.setCameraOnSide(door.side);
      }

      this.updateSelectedViewboxOption();
      this.updatePricesForDoorFinishes();
      this.updatePricesForDoorHandleTypes();
      this.updatePricesForHingeTypes();
      this.changeDetector.detectChanges();
    });
    this.threeDService.doorRemoved$.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.selectedDoor = null;
      this.changeDetector.detectChanges();
    });
    this.threeDService.doorReplaced$.pipe(takeUntil(this.unsubscribe)).subscribe((door: DoorPosition) => {
      this.selectedDoor.doorModel = door.doorModel;
      this.selectedDoor.left = door.left;

      if (this.slider) {
        this.slider.positionFromLeftLimit = this.calculateRemainingSpaceToLeft();
        this.slider.positionFromRightLimit = this.calculateRemainingSpaceToRight();
        this.slider.setViewPosition();
      }

      this.changeDetector.detectChanges();
    });

    this.threeDService.doorSelectionRemoved$.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.selectedDoor = null;
      this.changeDetector.detectChanges();
    });

    this.threeDService.doorDroppedOffWall$.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.selectedDoor = null;
      this.changeDetector.detectChanges();
    });

    this.threeDService.doorCollision$.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.collided$.emit(true);
    });

    this.threeDService.doorPositionSet$.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.selectedDoor = this.threeDService.selectedDoor;
      this.collided$.emit(false);
    });

    this.threeDService.selectFirstDoor();

    this.subscription = this.debouncer.pipe(debounceTime(300)).subscribe((mmFromLeft: number) => {
      if (this.selectedDoor) {
        this.selectedDoor.left = mmFromLeft;
        this.threeDService.setDoorPosition(this.selectedDoor.left);
        this.configurationService.updateDoorSettings();
      }
    });

    this.threeDService.wallSelectionChanged$.pipe(takeUntil(this.unsubscribe)).subscribe((side: WallSide) => {
      if (side > -1 && side < 5) {
        if (side < 5) {
          this.setCameraOnSide(side);
        }
        this.currentSide = side;
        this.choosingDoorType = true;
      } else {
        this.currentSide = undefined;
        this.choosingDoorType = false;
      }
    });

    this.threeDService.doorHeightChangedFailed$.subscribe(() => {
      if (this.selectedDoor) {
        this.doorHeight.value = this.selectedDoor.doorModel.openingHeight;
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.unsubscribe();

    this.priceService.updatePrice(this.configurationService.configuration);

    this.threeDService.wallSelectionEnabled = false;
    this.threeDService.doorSelectionEnabled = false;
    this.threeDService.deselect();
    this.subscription.unsubscribe();
    this.stepService.releaseBlockForwardUntilMoreThanOneDoorSelected();
    this.configurationService.registerNewDoors = false;
  }

  addDoorType(type: DoorType) {
    switch (type) {
      case DoorType.Turn: {
        if (!this.canUseTurnDoor) {
          break;
        }
        let height = this.configurationService.defaultTurnDoorheight;
        if (this.configurationService.height <= 1800) {
          height = this.configurationService.defaultTurnDoorheightUnder2m;
        }
        this.threeDService.addNewDoor(
          type as DoorType,
          this.currentSide,
          DoorDirection.left,
          this.configurationService.defaultTurnDoorWidth,
          height,
          0,
          [
            '',
            this.threeDService.materialFromFinishType(FinishTypes.STEEL),
            this.threeDService.materialFromFinishType(FinishTypes.STEEL),
          ]
        );
        break;
      }
      case DoorType.Slide: {
        if (!this.canUseSlideDoor) {
          break;
        }
        this.threeDService.addNewDoor(
          type as DoorType,
          this.currentSide,
          DoorDirection.left,
          this.configurationService.defaultSlideDoorWidth,
          this.configurationService.defaultSlideDoorheight,
          0,
          [
            '',
            this.threeDService.materialFromFinishType(FinishTypes.STEEL),
            this.threeDService.materialFromFinishType(FinishTypes.STEEL),
          ]
        );
        this.configurationService.productClass = ProductClass.PRO;
        break;
      }
    }
    this.configurationService.updateDoorSettings();
    this.priceService.updatePrice(this.configurationService.configuration);
  }

  selectedDoorDescription(): string {
    return this.translateService.instant('STEP5.' + DoorType[this.selectedDoor.doorModel.type].toUpperCase());
  }

  setDirection(direction: number) {
    if (this.selectedDoor) {
      if (this.selectedDoor.doorModel.type === DoorType.Turn) {
        this.selectedDoor.doorModel.direction = direction;
        this.changeDetector.detectChanges();
        this.threeDService.setDoorRotationSide(direction);
      } else if (this.selectedDoor.doorModel.type === DoorType.Slide) {
        this.selectedDoor.doorModel.direction = direction;
        this.changeDetector.detectChanges();
        this.threeDService.setDoorSlidingDirection(direction);
      }

      this.configurationService.updateDoorSettings();
    }
  }

  getDoorImage(door: DoorPosition): string {
    if (door.doorModel.type === DoorType.Turn) {
      if (door.doorModel.direction === DoorDirection.left) {
        return 'assets/images/doors/turning_left.png';
      }
      return 'assets/images/doors/turning.png';
    } else if (door.doorModel.direction === DoorDirection.left) {
      return 'assets/images/doors/sliding_left.png';
    }
    return 'assets/images/doors/sliding.png';
  }

  calculateRemainingSpaceToLeft(): number {
    if (this.selectedDoor) {
      return Math.round(this.selectedDoor.left);
    } else {
      return null;
    }
  }

  calculateRemainingSpaceToRight(): number {
    if (this.selectedDoor) {
      const wallPlacedOn = this.threeDService.getWallBySide(this.selectedDoor.side, this.selectedDoor.innerWallId);
      this.gatherInnerWallsForSideOfDoor();
      return wallPlacedOn.wallLength * 1000 - this.selectedDoor.left - this.selectedDoor.doorModel.panelWidth;
    } else {
      return null;
    }
  }

  newDoorLeftPosition(mmFromLeft: number) {
    if (this.selectedDoor) {
      if (this.threeDService.isValidDoorPosition(mmFromLeft)) {
        this.debouncer.next(mmFromLeft);
      }
    } else {
      return null;
    }
  }

  removeSelectedDoor() {
    this.threeDService.removeSelectedDoor();
    this.selectedDoor = null;
    this.configurationService.updateDoorSettings();
    this.configurationService.productClass = ProductClass.STANDARD;
    this.priceService.updatePrice(this.configurationService.configuration);
  }

  processSelectedExternalDoorFinish(doorFinish: ViewboxOptionWithPrice<FinishTypes>) {
    this.handleSelectionState(this.externalDoorFinishTypes, doorFinish);
    this.updateSelectedDoorFinish(this.selectedDoor, true, doorFinish.option);
  }

  processSelectedInternalDoorFinish(doorFinish: ViewboxOptionWithPrice<FinishTypes>) {
    this.handleSelectionState(this.internalDoorFinishTypes, doorFinish);
    this.updateSelectedDoorFinish(this.selectedDoor, false, doorFinish.option);
  }

  processSelectedDoorHandle(selection: ViewboxOptionWithPrice<DoorHandleType>) {
    this.handleSelectionState(this.doorHandleTypes, selection);
    this.configurationService.changeSelectedDoorHandle(selection.option as DoorHandleType);
    this.updatePricesForDoorHandleTypes();
  }

  processSelectedDoorHinge(selection: ViewboxOptionWithPrice<HingeType>) {
    this.handleSelectionState(this.doorHingeTypes, selection);
    this.configurationService.changeSelectedDoorHinge(selection.option as HingeType);
    this.updatePricesForHingeTypes();
  }

  handleSelectionState(doorFinishOptions: ViewboxOption<any>[], doorFinish: ViewboxOptionWithPrice<any>) {
    doorFinishOptions.forEach(finish => {
      finish.selected = false;
    });

    const doorFinishToUpdate = doorFinishOptions.find(f => f === doorFinish);
    if (doorFinishToUpdate) {
      doorFinishToUpdate.selected = true;
    }
  }

  updateSelectedDoorFinish(door: DoorPosition, outside: boolean, finish: FinishTypes) {
    this.configurationService.updateSelectedDoorFinish(outside, finish);
    if (outside) {
      door.setLeafExteriorFinish(finish);
    } else {
      door.setLeafInteriorFinish(finish);
    }
    this.configurationService.productClass = this.productClassificationService.GetFinishClassification(finish);
    this.priceService.updatePrice(this.configurationService.configuration);
    this.updatePricesForDoorFinishes();
  }

  updatePricesForDoorFinishes() {
    if (!this.pricesVisible) {
      return;
    }
    this.internalDoorFinishTypes.forEach(wallFinish => {
      wallFinish.priceChange = '...';
    });
    this.externalDoorFinishTypes.forEach(wallFinish => {
      wallFinish.priceChange = '...';
    });
    this.changeDetector.detectChanges();
    this.internalDoorFinishTypes.forEach(async wallFinish => {
      wallFinish.priceChange = await this.computePriceDifferenceForDoorFinishes(
        wallFinish.option as FinishTypes,
        false
      );
    });

    this.externalDoorFinishTypes.forEach(async wallFinish => {
      wallFinish.priceChange = await this.computePriceDifferenceForDoorFinishes(wallFinish.option as FinishTypes, true);
    });
    setTimeout(() => this.changeDetector.detectChanges());
  }

  async updatePricesForHingeTypes() {
    if (!this.pricesVisible) {
      return;
    }
    this.doorHingeTypes.forEach(hingeType => {
      hingeType.priceChange = '...';
    });
    await Promise.all(this.doorHingeTypes.map(async hingeType => {
      hingeType.priceChange = await this.computePriceDifferenceForDoorHinges(hingeType.option as HingeType);
    }));
    setTimeout(() => this.changeDetector.detectChanges());
  }

  async updatePricesForDoorHandleTypes() {
    if (!this.pricesVisible) {
      return;
    }
    this.doorHandleTypes.forEach(handleType => {
      handleType.priceChange = '...';
    });
    await Promise.all(this.doorHandleTypes.map(async handleType => {
      handleType.priceChange = await this.computePriceDifferenceForDoorHandles(handleType.option as DoorHandleType);
    }));

    setTimeout(() => this.changeDetector.detectChanges());
  }

  async computePriceDifferenceForDoorFinishes(newFinish: FinishTypes, outside: boolean): Promise<number | false> {
    if (!this.pricesVisible || !this.selectedDoor) {
      return false;
    }
    const clone = this.selectedDoor.clone();
    if (outside) {
      clone.setLeafExteriorFinish(newFinish);
    } else {
      clone.setLeafInteriorFinish(newFinish);
    }
    return await this.computePriceDifferenceBetweenDoors(this.selectedDoor, clone);
  }

  async computePriceDifferenceBetweenDoors(
    currentDoor: DoorPosition,
    afterChange: DoorPosition
  ): Promise<number | false> {
    const freezing = this.configurationService.purpose !== Purpose.Cooling;
    const wallThickness = this.configurationService.wallThickness;
    const oldPrice = await this.priceService.getPriceOfDoor(currentDoor, wallThickness, freezing);
    const newPrice = await this.priceService.getPriceOfDoor(afterChange, wallThickness, freezing);
    if (oldPrice === false || oldPrice.Price === undefined || newPrice === false || newPrice.Price === undefined) {
      return false;
    }
    return newPrice.Price - oldPrice.Price;
  }

  async computePriceDifferenceForDoorHinges(newHinge: HingeType): Promise<number | false> {
    if (!this.pricesVisible || !this.selectedDoor) {
      return false;
    }
    const clone = this.selectedDoor.clone();
    clone.hingeType = newHinge;
    return await this.computePriceDifferenceBetweenDoors(this.selectedDoor, clone);
  }

  async computePriceDifferenceForDoorHandles(newHandle: DoorHandleType): Promise<number | false> {
    if (!this.pricesVisible || !this.selectedDoor) {
      return false;
    }
    const clone = this.selectedDoor.clone();
    clone.doorHandleType = newHandle;
    return await this.computePriceDifferenceBetweenDoors(this.selectedDoor, clone);
  }

  updateSelectedViewboxOption() {
    this._externalDoorFinishOptions.forEach(dfo => {
      dfo.selected = false;
    });
    this._internalDoorFinishOptions.forEach(dfo => {
      dfo.selected = false;
    });
    this._doorHandleTypes.forEach(dfo => {
      dfo.selected = false;
    });
    this._doorHingeTypes.forEach(dfo => {
      dfo.selected = false;
    });
    const door = this.configurationService.configuration.settings.doorSettings.find(d => d.id === this.selectedDoor.id);
    if (!door) {
      return;
    }

    const currentExternalDoorFinish = this._externalDoorFinishOptions.find(
      dfo => dfo.option === door.leafExteriorFinish
    );

    if (currentExternalDoorFinish !== undefined) {
      currentExternalDoorFinish.selected = true;
    }

    const currentInternalDoorFinish = this._internalDoorFinishOptions.find(
      dfo => dfo.option === door.leafInteriorFinish
    );

    if (currentInternalDoorFinish !== undefined) {
      currentInternalDoorFinish.selected = true;
    }

    const currentDoorHinge = this._doorHingeTypes.find(dfo => dfo.option === door.hingeType);

    if (currentDoorHinge !== undefined) {
      currentDoorHinge.selected = true;
    }

    const currentDoorHandle = this._doorHandleTypes.find(dfo => dfo.option === door.doorHandleType);

    if (currentDoorHandle !== undefined) {
      currentDoorHandle.selected = true;
    }
  }

  flipInnerWall() {
    const innerWall = this.configurationService.configuration.settings.innerWalls.find(
      iw => iw.id == this.selectedDoor.innerWallId
    );
    if (innerWall) {
      this.threeDService.flipInnerWall(innerWall);
    }
  }

  private setCameraOnSide(side: WallSide) {
    if (side > -1 && side < 4) {
      if (this.configurationService.wallsHidden) {
        side = (side + 2) % 4;
      }
      this.threeDService.setCameraOnSide(side);
    }
  }

  private gatherInnerWallsForSideOfDoor() {
    let innerWalls: InnerWall[] = [];
    switch (this.selectedDoor.side) {
      case WallSide.north:
      case WallSide.south:
        innerWalls = this.threeDService
          .getInnerWalls()
          .filter(t => t.placedOnSide == WallSide.north || t.placedOnSide == WallSide.south);
        break;
      case WallSide.east:
      case WallSide.west:
        innerWalls = this.threeDService
          .getInnerWalls()
          .filter(t => t.placedOnSide == WallSide.east || t.placedOnSide == WallSide.west);
        break;
      default:
        return [];
    }
    innerWalls.forEach(iw => {
      if (iw.placedOnSide !== this.selectedDoor.side) {
        const wall = this.threeDService.getWallBySide(this.selectedDoor.side);
        const innerWallCompensation =
          this.configurationService.wallThickness +
          (this.configurationService.wallThickness <= 80
            ? this.configurationService.roundedWallCorrectionThickness * 2
            : 0);
        iw = {
          left: wall.wallLength * 1000 - iw.left - innerWallCompensation,
          placedOnSide: iw.placedOnSide,
        } as InnerWall;
      }
    });
    return innerWalls;
  }
}
